import React, { useState } from 'react'
import "./Contact.css"
import Header from './Header'
import PersonIcon from '@mui/icons-material/Person';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import EmailIcon from '@mui/icons-material/Email';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import {db, collection, addDoc, doc, setDoc} from "./firebase"


const Contact = () => {

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async(event) => {

    event.preventDefault();
    let form = {
      name: name,
      email: email,
      subject: subject,
      message: message,
    };

   

    try {
      const docRef = await addDoc(collection(db, "email"), form);
    
      
    } catch (e) {
      console.error("Error adding document: ", e);
    }

    
    setName("")
    setEmail("")
    setSubject("")
    setMessage("")
    alert("Message sent")
  }

  return (
    <div>
        
        <div className="contact">
          <div className="contact__header">
            <h1>
              Contact me
            </h1>
          </div>

          <div className="contact__info">
            <div className="contact__address">
              <h2>
                Get in Touch
              </h2>

              <p>
                Please feel free to contact for inquiries, work or collaboration on big or small projects.
              </p>

              <div className="name">
                <PersonIcon  style={{color: "rgb(136, 47, 219)",
                                    fontSize: "36px"}}/>
                <div className="name__info">
                  <h1>
                    Name
                  </h1>
                  <p>
                    Edward Ndlovu
                  </p>
                </div>
                
              </div>

              <div className="address">
                <LocationOnIcon  style={{color: "rgb(136, 47, 219)",
                                        fontSize: "36px"}}/>
                <div className="address__info">
                  <h1>
                    Address
                  </h1>
                  <p>
                    South Africa
                  </p>
                </div>
                
              </div>

              <div className="email">
                <EmailIcon style={{color: "rgb(136, 47, 219)",
                                  fontSize: "36px"}}/>
                <div className="email__info">
                  <h1>
                    Email
                  </h1>
                  <p>
                    Edwardndlovueddizar@gmail.com
                  </p>
                </div>
                
              </div>

              <div className="email">
                <WhatsAppIcon style={{color: "rgb(136, 47, 219)",
                                  fontSize: "36px"}}/>
                <div className="email__info">
                  <h1>
                    Whatsapp
                  </h1>
                  <p>
                    +27813276661
                  </p>
                </div>
                
              </div>

            </div>

            <div className="contact__form">
              <form onSubmit={handleSubmit} action="submit">
                <div className="name__email">
                  <input type="text" placeholder="Name" value={name} onChange={e => setName(e.target.value)}  required />
                  <input type="email"  placeholder='Email' value={email} onChange={e => setEmail(e.target.value)} required />
                </div>
                

                <input type="text" placeholder='Subject' value={subject} onChange={e => setSubject(e.target.value)} required />

                <textarea placeholder="Message..." value={message} onChange={e => setMessage(e.target.value)}required>
                
                </textarea>

                <button type="submit">Send Message</button>
                
              </form>

              
            </div>

          </div>
        </div>
    </div>
  )
}

export default Contact